export default "__VITE_ASSET__BmukjhT6__"